// Hooks
import { useState } from 'react';

// Components
import PlaybooksGrid from '../PlaybooksGrid/PlaybooksGrid';
import ProductFeatures from '../ProductFeatures/ProductFeatures';
import PropositionBlock from '../PropositionBlock/PropositionBlock';

const ContentToggle = (props) => {
  const { menu, entries, onToggle, modifier } = props;

  const [activeToggle, setActiveToggle] = useState(0);

  const handleSetToggle = (value) => {
    const index = parseInt(value, 2);
    if (activeToggle !== index) setActiveToggle(index);
  };

  return (
    <div className={`ContentToggle ${modifier || ''}`}>
      {menu && (
        <div className="ContentToggle-menu">
          <div className="ContentToggle-menuWrapper">
            {menu.map((item, index) => (
              <button
                type="button"
                onClick={() => {
                  handleSetToggle(index);
                  if (onToggle) {
                    onToggle(index);
                  }
                }}
                className={`ContentToggle-menuItem ${activeToggle === index ? 'is-active' : ''}`}
                key={`ContentToggle-menuItem--${index}`}
              >
                <span className="ContentToggle-menuLabel">{item.label}</span>
              </button>
            ))}
          </div>
        </div>
      )}
      {entries && (
        <div className="ContentToggle-container">
          {entries.map((group, groupIndex) => (
            <div
              className={`ContentToggle-group ${activeToggle === groupIndex ? 'is-active' : ''}`}
              key={`ContentToggle-group--${groupIndex}`}
            >
              {group.map((component, componentIndex) => {
                switch (component.type) {
                  case 'productFeatures':
                    return (
                      <ProductFeatures
                        {...component.data}
                        modifiers={['ProductFeatures--contentToggle']}
                        key={`component--${groupIndex}--${componentIndex}`}
                        darkTheme={!!modifier?.includes('abmPage')}
                      />
                    );
                  case 'propositions':
                    return (
                      <PropositionBlock
                        {...component.data}
                        modifiers={['PropositionBlock--contentToggle']}
                        key={`component--${groupIndex}--${componentIndex}`}
                      />
                    );
                  case 'playbooksGrid':
                    return (
                      <PlaybooksGrid
                        {...component.data}
                        modifiers={!modifier && ['PlaybooksGrid--contentToggle']}
                        key={`component--${groupIndex}--${componentIndex}`}
                        buttonTop
                      />
                    );
                  default:
                    return '';
                }
              })}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ContentToggle;
